"use client";

import { c as _c } from "react/compiler-runtime";
import { PostAuthors } from "@/views/post/partials/PostAuthors/PostAuthors";
import { useLabels } from "@/lib/labels/LabelsProvider";
interface Author {
  id?: string | null;
  name?: string | null;
  slug?: string | null;
  avatarUrl?: string | null;
}
export interface ArticleAuthorsProps {
  /**
   * Array of populated authors from the post
   */
  authors?: Author[] | null;
  /**
   * Additional CSS classes for the container
   */
  className?: string;
}

/**
 * Displays article authors with localized "Author/Authors" label.
 * Thin wrapper over PostAuthors that provides article-specific labels.
 */
export function ArticleAuthors(t0) {
  const $ = _c(5);
  const {
    authors,
    className: t1
  } = t0;
  const className = t1 === undefined ? "mt-8" : t1;
  const labels = useLabels();
  let t2;
  if ($[0] !== authors || $[1] !== className || $[2] !== labels.articlePage.author || $[3] !== labels.articlePage.authors) {
    t2 = <PostAuthors authors={authors} className={className} authorLabel={labels.articlePage.author} authorsLabel={labels.articlePage.authors} />;
    $[0] = authors;
    $[1] = className;
    $[2] = labels.articlePage.author;
    $[3] = labels.articlePage.authors;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}